/**
 * External dependencies
 */
import { HeaderIcon } from '~cartzillagb/icons'
import { disabledBlocks, i18n } from 'cartzillagb'

import {
	createButtonAttributes,
	createResponsiveAttributes,
	createAllCombinationAttributes,
} from '~cartzillagb/util'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'
import deprecated from './deprecated'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'

export const schema = {
	blockId: {
		type: 'string',
	},

	enableContainer: {
		type: 'boolean',
		default: true,
	},

	enableHeader: {
		type: 'boolean',
		default: true,
	},

	headerStyle: {
		type: 'string',
		default: 'style-v1',
	},

	// Title.
	showTitle: {
		type: 'boolean',
		default: true,
	},

	title: {
		type: 'string',
		default: __( 'Title for This Block', i18n ),
	},

	// Header Button.
	showHeaderButton: {
		type: 'boolean',
		default: false,
	},

	...createButtonAttributes( 'headerButton%s', {
		defaultText: 'More products',
		defaultIcon: 'czi-arrow-right',
		defaultSize: 'sm',
		defaultDesign: 'outline',
		backgroundColor: 'accent',
		iconAfterText: true,
	} ),

	// Footer Button.
	showFooterButton: {
		type: 'boolean',
		default: true,
	},

	...createButtonAttributes( 'footerButton%s', {
		defaultText: 'More products',
		defaultIcon: 'czi-arrow-right',
		defaultDesign: 'outline',
		backgroundColor: 'accent',
		iconAfterText: true,
	} ),

	// Spacing.
	...createResponsiveAttributes( 'header%sBottomMargin', {
		type: 'number',
		default: '',
	} ),

	...createResponsiveAttributes( 'footer%sTopMargin', {
		type: 'number',
		default: '',
	} ),

	// Carousel Options
	...createAllCombinationAttributes(
		'slidesToShow%s', {
			type: 'number',
		},
		[ '', 'Laptop', 'Tablet', 'Mobile' ]
	),

	...createAllCombinationAttributes(
		'slidesToScroll%s', {
			type: 'number',
		},
		[ '', 'Laptop', 'Tablet', 'Mobile' ]
	),

	dots: {
		type: 'boolean',
		default: true,
	},

	arrows: {
		type: 'boolean',
		default: true,
	},

	infinite: {
		type: 'boolean',
		default: true,
	},
	autoplay: {
		type: 'boolean',
		default: false,
	},
	autoplaySpeed: {
		type: 'number',
		default: 3000,
	},

	
}

export const name = 'czgb/products-carousel'

export const settings = {
	title: __( 'Products Carousel', i18n ),
	icon: HeaderIcon,
	category: 'cartzillagb',
	example: {
        innerBlocks: [ { name: 'czgb/products' } ],
    },
	keywords: [
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	description: __( 'A styled products carousel that you can add other blocks inside. Use this to create unique layouts.', i18n ),
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	deprecated,
	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-general': true,
		'advanced-responsive': true,
		'advanced-block-spacing': true,
		'custom-css': {
			default: applyFilters( 'cartzillagb.products-carousel.custom-css.default', '' ),
		},
	},
}